function ctaMapper(entity) {
  return {
    type: 'call',
    ...entity,
  }
}

export default ctaMapper
